module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gPageBorder",
    attrs: {
      "id": ""
    }
  }, [_c('el-form', {
    ref: "form",
    staticClass: "gForm",
    attrs: {
      "label-position": "right",
      "rules": _vm.rules,
      "label-width": "14.5%",
      "model": _vm.form
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.risk_name'),
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_filestss'),
      "prop": "desc"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.desc),
      callback: function($$v) {
        _vm.$set(_vm.form, "desc", $$v)
      },
      expression: "form.desc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "background": "#D3DCE6",
      "height": "1px"
    },
    attrs: {
      "prop": ""
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_stmgpsw'),
      "prop": ""
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.form.ispsw),
      callback: function($$v) {
        _vm.$set(_vm.form, "ispsw", $$v)
      },
      expression: "form.ispsw"
    }
  }), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.ispsw),
      expression: "form.ispsw"
    }],
    staticStyle: {
      "margin-left": "8px",
      "width": "calc(100% - 61px)"
    },
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.psw),
      callback: function($$v) {
        _vm.$set(_vm.form, "psw", $$v)
      },
      expression: "form.psw"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_setcallf'),
      "prop": ""
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.form.iscall),
      callback: function($$v) {
        _vm.$set(_vm.form, "iscall", $$v)
      },
      expression: "form.iscall"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.iscall),
      expression: "form.iscall"
    }]
  }, [_c('el-radio', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.form.callvl),
      callback: function($$v) {
        _vm.$set(_vm.form, "callvl", $$v)
      },
      expression: "form.callvl"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_close')))]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.form.callvl),
      callback: function($$v) {
        _vm.$set(_vm.form, "callvl", $$v)
      },
      expression: "form.callvl"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_open')))])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_mapsl'),
      "prop": ""
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.form.ismap),
      callback: function($$v) {
        _vm.$set(_vm.form, "ismap", $$v)
      },
      expression: "form.ismap"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.ismap),
      expression: "form.ismap"
    }]
  }, [_c('el-radio', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.form.map),
      callback: function($$v) {
        _vm.$set(_vm.form, "map", $$v)
      },
      expression: "form.map"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_bdmap')))]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.form.map),
      callback: function($$v) {
        _vm.$set(_vm.form, "map", $$v)
      },
      expression: "form.map"
    }
  }, [_vm._v(_vm._s('Google' + _vm.$t('app_map')))])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": 'API ' + _vm.$t('app_protocal'),
      "prop": ""
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.form.ishttp),
      callback: function($$v) {
        _vm.$set(_vm.form, "ishttp", $$v)
      },
      expression: "form.ishttp"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.ishttp),
      expression: "form.ishttp"
    }]
  }, [_c('el-radio', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.form.http),
      callback: function($$v) {
        _vm.$set(_vm.form, "http", $$v)
      },
      expression: "form.http"
    }
  }, [_vm._v("HTTP")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.form.http),
      callback: function($$v) {
        _vm.$set(_vm.form, "http", $$v)
      },
      expression: "form.http"
    }
  }, [_vm._v("HTTPS")]), _vm._v(" "), _c('label', {
    staticStyle: {
      "margin-left": "16px"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_prtsltip')))])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": 'Appstore ' + _vm.$t('app_param'),
      "prop": ""
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.form.isstore),
      callback: function($$v) {
        _vm.$set(_vm.form, "isstore", $$v)
      },
      expression: "form.isstore"
    }
  }, [_vm._v("            off-text=\"\">\n          ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.isstore),
      expression: "form.isstore"
    }]
  }, [_c('label', {
    staticStyle: {
      "margin-left": "16px"
    }
  }, [_vm._v("               IP")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "300px",
      "margin-left": "8px"
    },
    model: {
      value: (_vm.form.sip),
      callback: function($$v) {
        _vm.$set(_vm.form, "sip", $$v)
      },
      expression: "form.sip"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "margin-left": "16px"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_port')))]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "200px",
      "margin-left": "8px"
    },
    model: {
      value: (_vm.form.sport),
      callback: function($$v) {
        _vm.$set(_vm.form, "sport", $$v)
      },
      expression: "form.sport"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_rgsvpm'),
      "prop": ""
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.form.isauth),
      callback: function($$v) {
        _vm.$set(_vm.form, "isauth", $$v)
      },
      expression: "form.isauth"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.isauth),
      expression: "form.isauth"
    }]
  }, [_c('label', {
    staticStyle: {
      "margin-left": "16px"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_rgsvip')))]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "300px",
      "margin-left": "8px"
    },
    model: {
      value: (_vm.form.aip),
      callback: function($$v) {
        _vm.$set(_vm.form, "aip", $$v)
      },
      expression: "form.aip"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "margin-left": "16px"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_port')))]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "200px",
      "margin-left": "8px"
    },
    model: {
      value: (_vm.form.aport),
      callback: function($$v) {
        _vm.$set(_vm.form, "aport", $$v)
      },
      expression: "form.aport"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_bgntpm'),
      "prop": ""
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.form.isnotify),
      callback: function($$v) {
        _vm.$set(_vm.form, "isnotify", $$v)
      },
      expression: "form.isnotify"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.isnotify),
      expression: "form.isnotify"
    }]
  }, [_c('label', {
    staticStyle: {
      "margin-left": "16px"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_bgntip')))]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "300px",
      "margin-left": "8px"
    },
    model: {
      value: (_vm.form.nip),
      callback: function($$v) {
        _vm.$set(_vm.form, "nip", $$v)
      },
      expression: "form.nip"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "margin-left": "16px"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_port')))]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "200px",
      "margin-left": "8px"
    },
    model: {
      value: (_vm.form.nport),
      callback: function($$v) {
        _vm.$set(_vm.form, "nport", $$v)
      },
      expression: "form.nport"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.save('form')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_save')))])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-635a4f7c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/system/device/edit.vue
// module id = 1061
// module chunks = 0